import { eLopTinChiKetQuaActionsObj } from "../../action-types/lop-tin-chi/ILopTinChiKetQuaActions";
import { generateActions } from "../generateActions";

export const lopTinChiKetQuaActions = {
  ...generateActions(eLopTinChiKetQuaActionsObj, "LOP_TIN_CHI_KET_QUA"),
  
};
